import { Directive, HostBinding, Input } from '@angular/core';
import { ButtonI } from './buttons.component';

@Directive({
  selector: '[analysisBtn]',
})
export class ButtonsDirective {
  @Input()
  disabledButton: boolean;

  @Input()
  kindButton: ButtonI['kind'] = 'primary';

  @Input()
  sizeButton: ButtonI['size'] = 'medium';

  @HostBinding('class.-primary') get PrimaryButton() {
    return this.kindButton === 'primary';
  }

  @HostBinding('class.-primary-ghost') get PrimaryGhostButton() {
    return this.kindButton === 'primary-ghost';
  }

  @HostBinding('class.-secondary') get SecondaryButton() {
    return this.kindButton === 'secondary';
  }

  @HostBinding('class.-secondary-ghost') get SecondaryGhostButton() {
    return this.kindButton === 'secondary-ghost';
  }
  
  @HostBinding('class.-ghost') get DisableButton() {
    return this.kindButton === 'ghost';
  }

  @HostBinding('class.-danger') get DangerButton() {
    return this.kindButton === 'danger';
  }

  @HostBinding('class.-danger-ghost') get DangerhostButton() {
    return this.kindButton === 'danger-ghost';
  }

  @HostBinding('class.-square') get SquareButton() {
    return this.kindButton === 'square';
  }

  @HostBinding('class.-small') get SmallButton() {
    return this.sizeButton === 'small';
  }

  @HostBinding('class.-medium') get MediumButton() {
    return this.sizeButton === 'medium';
  }

  @HostBinding('class.-large') get LargeButton() {
    return this.sizeButton === 'large';
  }

  @HostBinding('class.-disabled') get DisabledButton() {
    return this.disabledButton;
  }

  constructor() {}
}
